/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs */

const en__field_enum_mzs_staatsexamen_lehramt22 = /** @type {(inputs: _Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

const de__field_enum_mzs_staatsexamen_lehramt22 = /** @type {(inputs: _Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Lehramt" |
*
* @param {_Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_staatsexamen_lehramt22 = /** @type {((inputs?: _Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Staatsexamen_Lehramt22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_staatsexamen_lehramt22(inputs)
	return de__field_enum_mzs_staatsexamen_lehramt22(inputs)
});
export { _field_enum_mzs_staatsexamen_lehramt22 as "_field_enum_MZS_STAATSEXAMEN_LEHRAMT" }